module.exports = {"status":"Sorry, we're experiencing some issues with our services. Please come back later."}


//////////////////
// WEBPACK FOOTER
// ./src/components/Stripe/locales/en.json
// module id = 2011
// module chunks = 0